var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VueAvatar',{staticClass:"h-full w-full object-cover",attrs:{"alt":"Company logo","rounded":false,"size":_vm.size,"src":_vm.tenant.avatarUrl,"username":_vm.tenant.slug || ''}})
}
var staticRenderFns = []

export { render, staticRenderFns }